import cn from 'classnames';
import Image from 'next/image';
import React, { ReactNode } from 'react';
import { defaultLoader } from 'utils/images';

import s from './Plate.module.scss';

interface IPlate {
  imageSrc?: string;
  imageTitle?: string;
  heading?: JSX.Element | string;
  children?: ReactNode;
  isColumns?: boolean;
  isSecondary?: boolean;
  isNarrow?: boolean;
  isVerticalSpaced?: boolean;
  className?: string;
  headingClassName?: string;
}

const Plate = ({
  imageSrc,
  imageTitle,
  children,
  heading,
  isColumns,
  isSecondary,
  isNarrow,
  isVerticalSpaced,
  className,
  headingClassName
}: IPlate) => (
  <div
    className={cn(
      s.Plate,
      {
        isColumns,
        isSecondary: isSecondary,
        isNarrow: isNarrow,
        isVerticalSpaced
      },
      className
    )}
  >
    {imageSrc && (
      <div className={s.Plate__imageHolder}>
        <Image
          loader={defaultLoader}
          sizes="(max-width: 480px) 100vw, 412px"
          width={412}
          height={275}
          quality={60}
          src={imageSrc}
          title={imageTitle}
          alt={imageTitle ?? ''}
        />
      </div>
    )}
    {heading && <div className={cn(s.Plate__heading, headingClassName)}>{heading}</div>}
    {children && <div className={s.Plate__content}>{children}</div>}
  </div>
);

export default Plate;
